import axios from 'axios';
import { env } from '@/lib/env';
import { formatApiError } from '@/lib/vibeChatApi';

/** Master-agent base for deploy (not incidents report proxy). */
export function getOrchestratorApiBase() {
  const orchestrator = (env('REACT_APP_ORCHESTRATOR_URL') || '').trim().replace(/\/$/, '');
  if (orchestrator) return orchestrator;
  const backend = env('REACT_APP_BACKEND_URL') || '';
  if (backend.includes('localhost') || backend.includes('127.0.0.1')) {
    return 'http://localhost:8080';
  }
  return '';
}

/**
 * POST /abap/deploy — deploy ABAP source to SAP via the Halo Master Agent (:8080).
 * Chat uses gateway → aistudioapi; deploy uses orchestrator directly.
 */
export async function deployAbapCode({
  code,
  objectName,
  description = '',
  objectType = 'PROG',
  packageName = '$TMP',
}) {
  const apiBase = getOrchestratorApiBase();
  if (!apiBase) {
    throw new Error(
      'Master agent URL is not configured (set REACT_APP_ORCHESTRATOR_URL, e.g. http://localhost:8080)',
    );
  }

  const response = await axios.post(`${apiBase}/abap/deploy`, {
    code,
    object_name: objectName,
    object_type: objectType,
    description,
    package: packageName,
  });
  return response.data;
}

export { formatApiError };
